import { useState } from 'react';
import { ModeToggle } from './ModeToggle';

interface PastePanelProps {
  onParse: (summary: string, mode: 'simple' | 'advanced') => void;
  loading: boolean;
}

export default function PastePanel({ onParse, loading }: PastePanelProps) {
  const [summary, setSummary] = useState('');
  const [mode, setMode] = useState<'simple' | 'advanced'>('simple');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (summary.trim()) {
      onParse(summary, mode);
    }
  };

  return (
    <div className="flex flex-col h-full p-8">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-2">
          Paste Executive Summary
        </h2>
        <p className="text-gray-600">
          Paste the Executive Summary from your Gemini Gem research below.
        </p>
      </div>

      <ModeToggle mode={mode} onChange={setMode} />

      <form onSubmit={handleSubmit} className="flex flex-col flex-1">
        <textarea
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
          placeholder="Paste your Executive Summary here..."
          className="flex-1 w-full p-4 border-2 border-gray-300 rounded-lg focus:border-cloudflare-orange focus:outline-none resize-none font-mono text-sm"
          disabled={loading}
        />

        <button
          type="submit"
          disabled={loading || !summary.trim()}
          className="mt-6 w-full bg-cloudflare-orange text-white font-semibold py-4 px-6 rounded-lg hover:bg-orange-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
        >
          {loading ? (
            <span className="flex items-center justify-center">
              <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
              Analyzing...
            </span>
          ) : (
            'Generate Value Map'
          )}
        </button>
      </form>
    </div>
  );
}
